import { render } from "./DistributorTable.vue?vue&type=template&id=0929afa1&scoped=true"
import script from "./DistributorTable.vue?vue&type=script&lang=js"
export * from "./DistributorTable.vue?vue&type=script&lang=js"

import "./DistributorTable.vue?vue&type=style&index=0&id=0929afa1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0929afa1"]])

export default __exports__